const BusinessName = () => {
  return (
    <div>
      <form>
        <label className="mt-7 flex items-center gap-x-6">
          <h3 className=" w-[225px] font-pop text-xl font-bold text-darkGreen">
            Business Name *
          </h3>
          <input
            className="font-regular w-full border border-solid border-black border-opacity-50 py-6 px-8 font-pop text-base outline-none"
            type="text"
            name="name"
            placeholder="Blue tech plumber wa"
          />
        </label>
      </form>
    </div>
  );
};

export default BusinessName;
